"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyProfileClientImpl = void 0;
const HttpClientImpl_1 = require("./HttpClientImpl");
class CompanyProfileClientImpl extends HttpClientImpl_1.HttpClientImpl {
    constructor(options, prefix) {
        super(options);
        this.getPublicCompanyProfile = async (companyId) => {
            return this.get(`${this.prefix}/public/${companyId}`);
        };
        this.getCompanyProfile = async () => {
            return this.get(`${this.prefix}/profile`);
        };
        this.updateProfile = async (request) => {
            return this.put(`${this.prefix}/profile`, request);
        };
        this.updateProfileImage = async (data) => {
            return this.postFile(`${this.prefix}/profile/profileimage`, data);
        };
        this.uploadImages = async (data) => {
            return this.postFile(`${this.prefix}/profile/images`, data);
        };
        this.deleteImage = async (imageId) => {
            return this.delete(`${this.prefix}/profile/images/${imageId}`);
        };
        this.prefix = `${prefix}/v1/company/companyprofile`;
    }
}
exports.CompanyProfileClientImpl = CompanyProfileClientImpl;
